// Copyright (c) 2016 Deere & Company

import PartsCoverageSearchReport from '../../../reports/parts-coverage-search/state-connector';

export default {
    component: PartsCoverageSearchReport,
    name: 'PARTS_COVERAGE_SEARCH',
    path: 'parts-coverage-search'
};



// WEBPACK FOOTER //
// ./src/routes/claims/reports/parts-coverage-search.js